'use client'
import Select from '@/ui/select'
import styles from './styles.module.css'
import useAuthStore from '@/store/auth';

export default function AccountModal({openBurgerModal, dict}) {
    const { userName } = useAuthStore();
    const { account } = dict.select

    const accountOptions = [
        {id: 1, title: account.my_account, link: "#"},
        {id: 2, title: account.log_out, link: "#"},
    ]

    return (
        <section className={styles.account_modal}>
            <Select onClick={openBurgerModal} options={accountOptions} defaultText={userName} type="account" dict={dict} />
        </section>
    )
}